module.exports = __webpack_public_path__ + "static/img/information-img.9fda1bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/information-img.png
// module id = dz6g
// module chunks = 3